import { render, staticRenderFns } from "./comtradecard.vue?vue&type=template&id=a0a93cda&scoped=true"
import script from "./comtradecard.vue?vue&type=script&lang=js"
export * from "./comtradecard.vue?vue&type=script&lang=js"
import style0 from "./comtradecard.vue?vue&type=style&index=0&id=a0a93cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a93cda",
  null
  
)

export default component.exports